module.exports = __webpack_public_path__ + "static/media/al.790143d0.svg";